<div class="onoff-container">
    <input type="range" min="0" max="1" value="0" [class.is-on]="value == true" [(ngModel)]="value" id="rangebox" name="rangebox"/>
    <label for="rangebox" style="font-weight:normal;" [hidden]="!label">{{label}}</label>
</div>